/**
 * @fileoverview gRPC-Web generated client stub for acompanha.customers.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/customers/v1/customers.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.customers = {};
proto.acompanha.customers.v1 = require('./customers_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.customers.v1.CustomersServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.customers.v1.CustomersServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.customers.v1.ListCustomersRequest,
 *   !proto.acompanha.customers.v1.ListCustomersResponse>}
 */
const methodDescriptor_CustomersService_ListCustomers = new grpc.web.MethodDescriptor(
  '/acompanha.customers.v1.CustomersService/ListCustomers',
  grpc.web.MethodType.UNARY,
  proto.acompanha.customers.v1.ListCustomersRequest,
  proto.acompanha.customers.v1.ListCustomersResponse,
  /**
   * @param {!proto.acompanha.customers.v1.ListCustomersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.customers.v1.ListCustomersResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.customers.v1.ListCustomersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.customers.v1.ListCustomersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.customers.v1.ListCustomersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.customers.v1.CustomersServiceClient.prototype.listCustomers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.customers.v1.CustomersService/ListCustomers',
      request,
      metadata || {},
      methodDescriptor_CustomersService_ListCustomers,
      callback);
};


/**
 * @param {!proto.acompanha.customers.v1.ListCustomersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.customers.v1.ListCustomersResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.customers.v1.CustomersServicePromiseClient.prototype.listCustomers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.customers.v1.CustomersService/ListCustomers',
      request,
      metadata || {},
      methodDescriptor_CustomersService_ListCustomers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.customers.v1.GetCustomerRequest,
 *   !proto.acompanha.customers.v1.GetCustomerResponse>}
 */
const methodDescriptor_CustomersService_GetCustomer = new grpc.web.MethodDescriptor(
  '/acompanha.customers.v1.CustomersService/GetCustomer',
  grpc.web.MethodType.UNARY,
  proto.acompanha.customers.v1.GetCustomerRequest,
  proto.acompanha.customers.v1.GetCustomerResponse,
  /**
   * @param {!proto.acompanha.customers.v1.GetCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.customers.v1.GetCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.customers.v1.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.customers.v1.GetCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.customers.v1.GetCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.customers.v1.CustomersServiceClient.prototype.getCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.customers.v1.CustomersService/GetCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomersService_GetCustomer,
      callback);
};


/**
 * @param {!proto.acompanha.customers.v1.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.customers.v1.GetCustomerResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.customers.v1.CustomersServicePromiseClient.prototype.getCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.customers.v1.CustomersService/GetCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomersService_GetCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.customers.v1.CreateCustomerRequest,
 *   !proto.acompanha.customers.v1.CreateCustomerResponse>}
 */
const methodDescriptor_CustomersService_CreateCustomer = new grpc.web.MethodDescriptor(
  '/acompanha.customers.v1.CustomersService/CreateCustomer',
  grpc.web.MethodType.UNARY,
  proto.acompanha.customers.v1.CreateCustomerRequest,
  proto.acompanha.customers.v1.CreateCustomerResponse,
  /**
   * @param {!proto.acompanha.customers.v1.CreateCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.customers.v1.CreateCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.customers.v1.CreateCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.customers.v1.CreateCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.customers.v1.CreateCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.customers.v1.CustomersServiceClient.prototype.createCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.customers.v1.CustomersService/CreateCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomersService_CreateCustomer,
      callback);
};


/**
 * @param {!proto.acompanha.customers.v1.CreateCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.customers.v1.CreateCustomerResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.customers.v1.CustomersServicePromiseClient.prototype.createCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.customers.v1.CustomersService/CreateCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomersService_CreateCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.customers.v1.UpdateCustomerRequest,
 *   !proto.acompanha.customers.v1.UpdateCustomerResponse>}
 */
const methodDescriptor_CustomersService_UpdateCustomer = new grpc.web.MethodDescriptor(
  '/acompanha.customers.v1.CustomersService/UpdateCustomer',
  grpc.web.MethodType.UNARY,
  proto.acompanha.customers.v1.UpdateCustomerRequest,
  proto.acompanha.customers.v1.UpdateCustomerResponse,
  /**
   * @param {!proto.acompanha.customers.v1.UpdateCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.customers.v1.UpdateCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.customers.v1.UpdateCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.customers.v1.UpdateCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.customers.v1.UpdateCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.customers.v1.CustomersServiceClient.prototype.updateCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.customers.v1.CustomersService/UpdateCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomersService_UpdateCustomer,
      callback);
};


/**
 * @param {!proto.acompanha.customers.v1.UpdateCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.customers.v1.UpdateCustomerResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.customers.v1.CustomersServicePromiseClient.prototype.updateCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.customers.v1.CustomersService/UpdateCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomersService_UpdateCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.customers.v1.DeleteCustomerRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_CustomersService_DeleteCustomer = new grpc.web.MethodDescriptor(
  '/acompanha.customers.v1.CustomersService/DeleteCustomer',
  grpc.web.MethodType.UNARY,
  proto.acompanha.customers.v1.DeleteCustomerRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.customers.v1.DeleteCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.customers.v1.DeleteCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.customers.v1.CustomersServiceClient.prototype.deleteCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.customers.v1.CustomersService/DeleteCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomersService_DeleteCustomer,
      callback);
};


/**
 * @param {!proto.acompanha.customers.v1.DeleteCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.customers.v1.CustomersServicePromiseClient.prototype.deleteCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.customers.v1.CustomersService/DeleteCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomersService_DeleteCustomer);
};


module.exports = proto.acompanha.customers.v1;

